import { Box, Button, Typography } from '@mui/material'
import { localStorageItemKeys } from '~constants/local-storage-items'
import { COLORS } from '~theme/colors'

export function ImpersonationRibbon() {
  const impersonating = localStorage.getItem(localStorageItemKeys.impersonate)
  if (!impersonating) {
    return null
  }

  const impersonate = JSON.parse(impersonating)
  if (!impersonate?.id || !impersonate.label) {
    removeImpersonation()
    return null
  }

  return (
    <Box
      sx={{
        background: COLORS.orange.tint3,
        py: 3,
        px: { xs: 2, sm: 5 },
        display: 'flex',
        gap: 3,
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1201,
      }}
    >
      <Typography>
        You are impersonating{' '}
        <Typography variant="paragraphBold1">{impersonate.label}</Typography>
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Button
          variant="contained"
          onClick={stopImpersonation}
          sx={{
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          Stop impersonation
        </Button>
      </Box>
    </Box>
  )
}

function removeImpersonation() {
  localStorage.removeItem(localStorageItemKeys.impersonate)
  window.location.reload()
}

function stopImpersonation() {
  localStorage.removeItem(localStorageItemKeys.impersonate)
  window.location.href = '/profile'
}
